module.exports = __webpack_public_path__ + "static/media/volumeOff.c234a932.svg";